import * as React from "react";
import { Editor } from 'react-draft-wysiwyg'
import { CPVariable } from "../models/CPVariable";
import SymbolSelectButtonComponent from "./SymbolSelectButtonsComponent";
import VariableSelectButtonComponent from "./VariableSelectButtonsComponent";

export interface RichTextEditorComponentProps {
    editorState: any,
    changeEditor: Function,
    placeholder: string,
    maxCharacters: number,
    readOnly: boolean,
    showSymbolDropdown: boolean
    variables?: Array<CPVariable>,
    toolbar?: any,
    editorStyle?: string,
    editorDisabledStyle?: string,
}

const RichTextEditorComponent = (props: RichTextEditorComponentProps) => {
    const getLengthOfSelectedText = () => {
        const currentSelection = props.editorState.getSelection();
        const isCollapsed = currentSelection.isCollapsed();

        let length = 0;

        if (!isCollapsed) {
            const currentContent = props.editorState.getCurrentContent();
            const startKey = currentSelection.getStartKey();
            const endKey = currentSelection.getEndKey();
            const startBlock = currentContent.getBlockForKey(startKey);
            const isStartAndEndBlockAreTheSame = startKey === endKey;
            const startBlockTextLength = startBlock.getLength();
            const startSelectedTextLength = startBlockTextLength - currentSelection.getStartOffset();
            const endSelectedTextLength = currentSelection.getEndOffset();
            const keyAfterEnd = currentContent.getKeyAfter(endKey);
            console.log(currentSelection)
            if (isStartAndEndBlockAreTheSame) {
                length += currentSelection.getEndOffset() - currentSelection.getStartOffset();
            } else {
                let currentKey = startKey;

                while (currentKey && currentKey !== keyAfterEnd) {
                    if (currentKey === startKey) {
                        length += startSelectedTextLength + 1;
                    } else if (currentKey === endKey) {
                        length += endSelectedTextLength;
                    } else {
                        length += currentContent.getBlockForKey(currentKey).getLength() + 1;
                    }

                    currentKey = currentContent.getKeyAfter(currentKey);
                };
            }
        }
        return length;
    }

    const handleBeforeInput = () => {
        const currentContent = props.editorState.getCurrentContent();
        const currentContentLength = currentContent.getPlainText('').length;
        const selectedTextLength = getLengthOfSelectedText();

        if (currentContentLength - selectedTextLength > props.maxCharacters - 1) {

            return 'handled';
        }
        return undefined
    }

    const handlePastedText = (pastedText) => {
        const currentContent = props.editorState.getCurrentContent();
        const currentContentLength = currentContent.getPlainText('').length;
        const selectedTextLength = getLengthOfSelectedText();

        if (currentContentLength + pastedText.length - selectedTextLength > props.maxCharacters) {

            return 'handled';
        }
        return undefined
    }

    const handleDroppedText = (droppedText) => {
        return 'handled';
    }

    const customButtons = () => {
        var customButtonArray: Array<JSX.Element> = []
        if (props.variables) {
            // @ts-ignore
            customButtonArray.push(<VariableSelectButtonComponent variables={props.variables} disabled={props.readOnly} />)
        }
        if (props.showSymbolDropdown) {
            // @ts-ignore
            customButtonArray.push(<SymbolSelectButtonComponent disabled={props.readOnly} />)
        }
        return customButtonArray
    }

    return (
        <Editor
            editorState={props.editorState}
            onEditorStateChange={props.changeEditor}
            rows="1"
            wrapperClassName="demo-wrapper"
            readOnly={props.readOnly}
            editorClassName={props.readOnly ? props.editorDisabledStyle ?? "calcpad-rte-editor-disabled" : props.editorStyle ?? "calcpad-rte-editor"}
            toolbarClassName={props.readOnly ? "calcpad-rte-toolbar-disabled" : "calcpad-rte-toolbar"}
            //stripPastedStyles={true}
            toolbar={props.toolbar ?? {
                options: ['inline', 'blockType', 'history', 'colorPicker', 'link', 'remove'],
                inline: {
                    options: ['bold', 'italic', 'underline', 'superscript', 'subscript'],
                    bold: { className: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option" },
                    italic: { className: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option" },
                    underline: { className: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option" },
                    superscript: { className: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option" },
                    subscript: { className: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option" },
                },
                blockType: {
                    className: props.readOnly ? "calcpad-rte-option-large-disabled" : "calcpad-rte-option-large",
                    dropdownClassName: props.readOnly ? "calcpad-rte-dropdown-disabled" : "calcpad-rte-dropdown",
                },
                history: {
                    undo: { className: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option" },
                    redo: { className: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option" },
                },
                colorPicker: {
                    className: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option",
                    popupClassName: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option"
                },
                link: {
                    link: { className: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option" },
                    unlink: { className: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option" },
                    popupClassName: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option",
                },
                remove: {
                    className: props.readOnly ? "calcpad-rte-option-disabled" : "calcpad-rte-option",
                }
            }}
            placeholder={props.placeholder}
            handleBeforeInput={handleBeforeInput}
            handlePastedText={handlePastedText}
            handleDrop={handleDroppedText}
            toolbarCustomButtons={customButtons()}
        />)
}

export default RichTextEditorComponent;